import React from 'react';
import classnames from 'classnames';
import SVG from './SVGWrapper';
import styles from './Icons.module.scss';
import { SVGProps } from '@repo/utils/types';

const AboutMeIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon about-me-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 24"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M17 0a7 7 0 017 7v10a7 7 0 01-7 7H7a7 7 0 01-7-7V7a7 7 0 017-7h10zm-.367 8.95c-1.72 0-2.946 1.359-2.946 3.042 0 1.839 1.287 3.052 3.04 3.053.914 0 1.768-.3 2.357-.854l-.577-.83c-.42.421-1.08.65-1.659.65-1.094 0-1.742-.733-1.838-1.599h4.472V12.1c0-1.827-1.106-3.15-2.85-3.15zm-5.322 0c-.877 0-1.646.542-1.97 1.058-.193-.625-.722-1.057-1.587-1.057-.89 0-1.647.577-1.9.925v-.781H4.592V14.9h1.262v-4.062c.265-.373.782-.77 1.347-.77.686 0 .95.421.95 1.046V14.9h1.262v-4.062c.252-.385.781-.77 1.346-.77.685 0 .962.421.962 1.046V14.9h1.262v-4.195c0-1.178-.613-1.754-1.672-1.754zm5.31 1.035c1.142 0 1.61.84 1.647 1.526h-3.27c.048-.697.553-1.526 1.623-1.526z"
    />
  </SVG>
);

const AngelListIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon angel-list-icon', styles.socIcon, props.className)}
    viewBox="0 0 18 26"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M5.167.58C4.61.565 4.22.87 3.814 1.73c-.232.578-.29 1.214-.29 1.907.174.752.348 1.502.58 2.254.337 1.038 1.07 3.198 1.631 4.855.031.012.062.023.108.046.224.138.312.214.411.302.114.102.242.233.375.378.115-.263.294-.51.549-.728.696-.462 1.508-.173 2.261-.173l.813.08c-.64-1.957-1.78-5.576-2.516-7.042-.407-.809-.812-1.56-1.334-2.253-.231-.347-.522-.636-.986-.751a1.814 1.814 0 00-.25-.025zm10.871.686c-.358.032-.752.243-1.158.619-.115.115-.29.23-.348.404-.637.751-1.102 1.676-1.508 2.543-.696 1.33-1.711 4.205-2.175 5.65-.022.079-.052.147-.078.221l.989.1c.645.072 2.291.281 3.43.447.47-1.349 1.247-3.564 1.616-4.665.29-.983.58-1.965.696-2.948.058-.693-.059-1.329-.523-1.907-.26-.347-.583-.496-.94-.464zM4.578 11.34a.939.939 0 00-.199.015c-.617.116-1.137.487-1.55.95-.028.031-.05.064-.076.095-.147.238-.233.483-.218.702v.056c-.002.446.174.637.29.925.405.807 1.218 1.85 2.107 2.835l.125.135c.246.27.495.54.744.802.424.422.91 1.121 1.592.82.43-.19.854-.674 1.008-1.12a.797.797 0 00.048-.263c0-.966-2.084-4.255-2.838-5.238-.271-.354-.587-.702-1.032-.714zm4.804.157c-.406 0-.754 0-1.16.115-.29.116-.523.29-.523.636a2 2 0 00.094.786c.118.193.233.395.346.605.092.1.191.2.315.286.406.289.928.461 1.45.577 1.16.231 2.377.232 3.595.232.29 0 .523 0 .813.058.29.058.348.288.406.577.058.232-.116.348-.29.405a7.062 7.062 0 01-.987.404c-1.392.52-2.435 1.445-3.19 2.716-.521.925-.695 1.907-.289 2.948.116.23.174.462.232.75.058.233.116.521.058.81-.58-.116-.928-.405-1.218-.867-.232-.462-.347-.982-.405-1.502-.059-.29-.06-.578-.06-.867.04-.358.094-.654.16-.908a2.777 2.777 0 01-.595.482c-.293.194-.74.215-1.117.183.03.065.06.132.087.196 0 .115.058.173.058.231.175.694-.116 1.33-.696 1.734-.464.346-1.043.346-1.565.23-.928-.23-1.775-.85-2.355-1.601-.29-.405-.58-.867-.637-1.33-.174-.462-.175-.694.115-.982.057.115.174.172.232.288.29.347.522.694.812 1.041.348.405.846.85 1.31 1.024.406.173.755.173 1.16 0 .348-.173.407-.404.348-.75l-.174-.347a8.423 8.423 0 00-1.566-2.197c-.348-.347-1.896-2.116-2.864-1.645-.674.433-1.11 1.098-1.237 1.98-.116.983 0 1.85.29 2.775.58 1.85 2.551 3.872 4.524 4.681a9.352 9.352 0 004.698.693c1.16-.058 2.319-.403 3.363-.923 2.088-1.04 3.48-2.717 4.35-4.855.406-1.04.638-2.196.696-3.352.008-.129.013-.259.019-.388 0-.365-.001-.992-.035-1.554a7.35 7.35 0 00-.101-.66 6.475 6.475 0 00-.151-.55c-.179-.35-.436-.65-.809-.836-.29-.115-.521-.23-.81-.347-1.798-.635-4.84-.81-6.697-.982zm-.334 3.987c.219.352.44.71.51 1.186.035.243.037.66-.063 1.124l.176-.23c.464-.693 1.102-1.155 1.798-1.675-.857-.054-1.663-.162-2.421-.405z"
    />
  </SVG>
);

const FacebookIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon facebook-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 24"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M12.82 24H1.324A1.325 1.325 0 010 22.675V1.325C0 .593.593 0 1.325 0h21.35C23.407 0 24 .593 24 1.325v21.35c0 .732-.593 1.325-1.325 1.325H16.56v-9.294h3.12l.466-3.622H16.56V8.77c0-1.048.29-1.763 1.795-1.763h1.918v-3.24c-.332-.045-1.47-.143-2.795-.143-2.766 0-4.659 1.688-4.659 4.788v2.67H9.692v3.623h3.127V24z"
    />
  </SVG>
);

const FlickrIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon flickr-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 11"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M23.913 5.327c0 2.942-2.355 5.328-5.266 5.328-2.913 0-5.27-2.386-5.27-5.328 0-2.94 2.357-5.327 5.27-5.327 2.91 0 5.266 2.386 5.266 5.327m-13.379 0c0 2.942-2.356 5.328-5.27 5.328C2.355 10.655 0 8.27 0 5.327 0 2.387 2.355 0 5.264 0c2.914 0 5.27 2.386 5.27 5.327"
    />
  </SVG>
);

const FoursquareIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon foursquare-icon', styles.socIcon, props.className)}
    viewBox="0 0 16 23"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M13.331 3.321l-.535 2.66c-.061.284-.321.536-.642.536H7.506c-.52 0-.948.44-.948.975v.583c0 .535.429.976.948.976h3.93c.366 0 .672.362.596.755-.077.41-.49 2.487-.536 2.708a.657.657 0 01-.642.535h-3.21c-.673.016-.81.031-1.208.535-.397.504-3.914 5.037-3.914 5.037-.03.047-.06.032-.06-.016V3.195c0-.362.29-.66.641-.66h9.647c.336 0 .673.346.581.786M14.034 0H2.125C.489 0 0 1.275 0 2.078v19.486c0 .96.474 1.244.734 1.354.26.11.948.189 1.437-.315l5.748-6.894c.092-.11.138-.11.199-.11h3.577c1.529 0 1.82-1.086 1.988-1.747.137-.551 1.712-8.422 2.201-10.909.367-1.92-.107-2.943-1.85-2.943"
    />
  </SVG>
);

const GithubIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon github-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 24"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M12 0C5.372 0 0 5.508 0 12.305c0 5.435 3.438 10.047 8.207 11.674.6.113.82-.267.82-.593 0-.292-.011-1.066-.017-2.093-3.338.744-4.043-1.65-4.043-1.65-.545-1.42-1.332-1.798-1.332-1.798-1.09-.764.083-.749.083-.749 1.204.087 1.837 1.268 1.837 1.268 1.071 1.88 2.809 1.338 3.493 1.022.109-.795.42-1.337.762-1.645-2.665-.31-5.466-1.365-5.466-6.08 0-1.343.467-2.442 1.235-3.302-.123-.311-.535-1.562.117-3.256 0 0 1.008-.33 3.3 1.261a11.241 11.241 0 013.005-.414c1.019.005 2.046.141 3.004.414 2.29-1.592 3.296-1.261 3.296-1.261.655 1.694.244 2.945.12 3.256.77.86 1.233 1.959 1.233 3.302 0 4.726-2.805 5.767-5.478 6.071.43.38.814 1.13.814 2.279 0 1.645-.015 2.971-.015 3.375 0 .329.216.712.825.591 4.765-1.63 8.2-6.239 8.2-11.672C24 5.508 18.627 0 12 0"
    />
  </SVG>
);

const HackerNewsIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon hacker-news-icon', styles.socIcon, props.className)}
    viewBox="0 0 22 22"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M20 0a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h18zM8.117 4.714H6.286l3.918 7.528v5.044h1.542V12.33l3.968-7.617h-1.709c-2.69 4.97-2.372 4.842-2.976 6.168-.496-1.198-.333-1.34-2.912-6.168z"
    />
  </SVG>
);

const InstagramIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon instagram-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 24"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M13.16 0c2.223.004 2.678.022 3.788.072 1.277.058 2.15.261 2.912.558.79.307 1.459.717 2.126 1.384A5.883 5.883 0 0123.37 4.14c.297.763.5 1.635.558 2.912C23.986 8.332 24 8.741 24 12c0 3.259-.014 3.668-.072 4.948-.058 1.277-.261 2.15-.558 2.912a5.883 5.883 0 01-1.384 2.126 5.883 5.883 0 01-2.126 1.384c-.763.297-1.635.5-2.912.558-1.28.058-1.689.072-4.948.072-3.259 0-3.668-.014-4.948-.072-1.277-.058-2.15-.261-2.912-.558a5.883 5.883 0 01-2.126-1.384A5.882 5.882 0 01.63 19.86c-.297-.763-.5-1.635-.558-2.912-.05-1.11-.068-1.565-.071-3.788v-2.32c.003-2.223.02-2.678.071-3.788C.13 5.775.333 4.902.63 4.14a5.882 5.882 0 011.384-2.126A5.882 5.882 0 014.14.63C4.903.333 5.775.13 7.052.072 8.162.022 8.617.004 10.84.001zm-.02 2.163h-2.28c-2.181.003-2.612.02-3.709.07-1.17.052-1.805.248-2.228.412-.56.218-.96.478-1.38.898-.42.42-.68.82-.898 1.38-.164.423-.36 1.058-.413 2.228-.05 1.097-.066 1.528-.07 3.71v2.279c.004 2.181.02 2.612.07 3.709.053 1.17.249 1.805.413 2.228.218.56.478.96.898 1.38.42.42.82.68 1.38.898.423.164 1.058.36 2.228.413 1.096.05 1.528.066 3.71.07h2.279c2.181-.004 2.613-.02 3.709-.07 1.17-.053 1.805-.249 2.228-.413.56-.218.96-.478 1.38-.898.42-.42.68-.82.898-1.38.164-.423.36-1.058.413-2.228.05-1.097.066-1.528.07-3.71V10.86c-.004-2.181-.02-2.612-.07-3.709-.053-1.17-.249-1.805-.413-2.228a3.717 3.717 0 00-.898-1.38c-.42-.42-.82-.68-1.38-.898-.423-.164-1.058-.36-2.228-.413-1.097-.05-1.528-.066-3.71-.07zM12 5.838a6.162 6.162 0 110 12.324 6.162 6.162 0 010-12.324zM12 8a4 4 0 100 8 4 4 0 000-8zm6.406-3.846a1.44 1.44 0 110 2.88 1.44 1.44 0 010-2.88z"
    />
  </SVG>
);

const LinkedInIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon linked-in-icon', styles.socIcon, props.className)}
    viewBox="0 0 22 20"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M22 20h-4.862v-7.03c0-1.841-.76-3.097-2.433-3.097-1.28 0-1.991.847-2.322 1.664-.124.294-.105.702-.105 1.11V20H7.461s.062-12.454 0-13.586h4.817v2.132c.285-.933 1.824-2.263 4.28-2.263 3.048 0 5.442 1.954 5.442 6.162V20zM2.59 4.714h-.031C1.006 4.714 0 3.675 0 2.36 0 1.017 1.036 0 2.62 0 4.2 0 5.173 1.014 5.204 2.355c0 1.317-1.004 2.36-2.615 2.36zm-2.035 1.7h4.288V20H.555V6.414z"
    />
  </SVG>
);

const MediumIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon medium-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 20"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M23.737 3.669c-.004-.004-.008-.008-.014-.011l-.008-.004L16.567.107a.744.744 0 00-.15-.054.82.82 0 00-.89.348l-4.115 6.637 5.164 8.33 7.183-11.586a.086.086 0 00-.022-.113M9.145 5.527v7.555l6.766 3.358L9.145 5.527m7.783 11.417l5.57 2.764c.724.36 1.312.108 1.312-.562V5.845l-6.882 11.099M7.97 3.68L.99.215A.806.806 0 00.633.123c-.305 0-.52.235-.52.629v14.96c0 .4.296.874.656 1.053l6.15 3.051a.992.992 0 00.443.116c.382 0 .65-.294.65-.786V3.748a.076.076 0 00-.043-.068"
    />
  </SVG>
);

const PinterestIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon pinterest-icon', styles.socIcon, props.className)}
    viewBox="0 0 22 22"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M11 0C4.927 0 0 4.925 0 11c0 4.504 2.709 8.374 6.586 10.075-.031-.767-.006-1.69.19-2.526.212-.893 1.415-5.993 1.415-5.993s-.35-.703-.35-1.742c0-1.63.945-2.847 2.12-2.847 1 0 1.485.752 1.485 1.652 0 1.005-.642 2.51-.972 3.903-.275 1.168.585 2.119 1.736 2.119 2.084 0 3.488-2.677 3.488-5.849 0-2.41-1.624-4.214-4.577-4.214-3.336 0-5.415 2.488-5.415 5.266 0 .96.282 1.635.724 2.158.205.242.232.337.158.614-.052.2-.173.69-.224.883-.073.278-.298.379-.55.275-1.537-.627-2.253-2.31-2.253-4.203 0-3.124 2.635-6.873 7.861-6.873 4.2 0 6.965 3.042 6.965 6.303 0 4.315-2.398 7.539-5.936 7.539-1.186 0-2.304-.642-2.687-1.37 0 0-.64 2.534-.774 3.023-.232.847-.69 1.696-1.107 2.356a11 11 0 003.118.451C17.075 22 22 17.075 22 11S17.075 0 11 0"
    />
  </SVG>
);

const QuoraIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon quora-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 25"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M22.098 19.602s-.122 1.794-1.756 1.794c-1.261 0-2.123-.96-2.93-2.208 2.292-1.996 3.747-4.976 3.747-8.307C21.16 4.871 16.423 0 10.581 0S.004 4.872.004 10.881c0 6.01 4.735 10.881 10.577 10.881 1.06 0 2.084-.16 3.05-.46 1.221 1.937 2.772 3.679 5.2 3.679 4.942 0 5.146-5.379 5.146-5.379h-1.879zm-11.517.367c-3.406 0-6.167-4.069-6.167-9.088 0-5.019 2.761-9.088 6.167-9.088 3.406 0 6.167 4.069 6.167 9.088 0 1.996-.437 3.841-1.177 5.34-.836-1.19-1.84-2.205-3.274-2.528-2.546-.573-4.738.57-5.432 1.141l.653 1.345s.66-.379 2.299 0c1.032.238 1.834 1.667 2.753 3.307a4.406 4.406 0 01-1.989.483z"
    />
  </SVG>
);

const RedditIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon reddit-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 20"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M15.57 13.163c-.897 0-1.65-.721-1.65-1.61 0-.889.753-1.633 1.65-1.633.897 0 1.624.744 1.624 1.633s-.727 1.61-1.624 1.61m.381 3.124c-.836.827-2.124 1.23-3.939 1.23l-.013-.001h-.013c-1.814 0-3.102-.402-3.937-1.229a.644.644 0 010-.918.66.66 0 01.927 0c.576.57 1.56.848 3.01.848l.013.001h.013c1.45 0 2.435-.279 3.012-.85a.66.66 0 01.927 0 .646.646 0 010 .92m-9.146-4.735c0-.888.753-1.633 1.649-1.633.897 0 1.624.745 1.624 1.633 0 .889-.727 1.61-1.624 1.61-.896 0-1.649-.721-1.649-1.61M19.998 1.3c.607 0 1.102.49 1.102 1.091 0 .602-.495 1.092-1.102 1.092-.607 0-1.102-.49-1.102-1.092 0-.601.495-1.091 1.102-1.091M24 9.785c0-1.576-1.294-2.858-2.885-2.858-.688 0-1.32.24-1.817.641-1.759-1.095-3.99-1.755-6.383-1.895l1.248-3.91 3.43.8a2.406 2.406 0 002.405 2.218c1.33 0 2.412-1.073 2.412-2.391S21.328 0 19.998 0a2.42 2.42 0 00-2.141 1.29L13.87.362a.656.656 0 00-.775.436L11.547 5.65c-2.578.063-5.001.725-6.889 1.884a2.886 2.886 0 00-1.774-.607C1.294 6.927 0 8.209 0 9.785c0 .975.495 1.836 1.249 2.352a4.972 4.972 0 00-.048.686c0 1.97 1.156 3.802 3.254 5.16C6.466 19.282 9.129 20 11.951 20s5.485-.716 7.496-2.018c2.099-1.357 3.255-3.19 3.255-5.16 0-.21-.015-.419-.04-.626A2.851 2.851 0 0024 9.786"
    />
  </SVG>
);

const SlideshareIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon slideshare-icon', styles.socIcon, props.className)}
    viewBox="0 0 22 23"
  >
    <path fill="none" fillRule="evenodd" d="M-.651.044h23.476v23.733H-.651z" />
    <path
      fillRule="nonzero"
      d="M21.604 11.911c-1.004 1.245-2.488 2.267-4.539 3.111.699 2.356.568 4.267-.261 5.778-.524.933-1.266 1.556-2.226 1.822-.829.267-1.57.222-2.225-.178-.698-.4-1.048-1.11-1.004-2.044v-4.044c-.044 0-.174-.045-.305-.09-.131-.044-.219-.044-.306-.044V20.4c.044.933-.305 1.6-1.003 2.044-.655.4-1.397.445-2.226.178-.96-.31-1.702-.933-2.225-1.866-.873-1.467-.96-3.423-.262-5.734-2.051-.844-3.535-1.91-4.538-3.11-.175-.312-.175-.579-.044-.8.175-.223.393-.223.742 0 .043 0 .087.044.13.088.044.044.088.089.132.089V2.71c0-.578.174-1.111.567-1.511.393-.4.829-.622 1.396-.622h15.317c.523 0 1.003.222 1.396.622s.567.933.567 1.511v8.622l.262-.177c.306-.223.567-.223.742 0 .13.177.13.444-.087.755zm-1.964.045V3.689c0-.711-.13-1.245-.393-1.511-.262-.311-.698-.445-1.352-.445H4.367c-.654 0-1.134.134-1.352.4-.262.267-.393.8-.393 1.556v8.355c.349.178.698.356 1.09.49.35.133.699.266 1.004.355.306.089.611.178 1.004.222.35.045.655.089.873.133.218.045.48.045.872.045h.699c.13 0 .349 0 .698-.045.349 0 .523-.044.523-.044.568 0 .917.089 1.179.356l.13.133c.219.222.48.4.742.622.044-.755.524-1.111 1.44-1.067h.437c.262 0 .436 0 .523.045.088.044.262 0 .568 0h.654c.175 0 .393-.045.655-.045.305-.044.523-.044.742-.088.218-.045.48-.09.741-.178.306-.045.568-.134.83-.222.261-.09.523-.223.829-.356.218-.133.48-.267.785-.444zm-8.858-2.223c0 .667-.262 1.29-.786 1.778-.523.489-1.134.756-1.876.756S6.767 12 6.244 11.51c-.524-.489-.786-1.067-.786-1.778 0-.71.262-1.289.786-1.777.523-.49 1.134-.712 1.876-.712s1.353.223 1.876.712c.524.488.786 1.066.786 1.777zm6.109 0c0 .667-.262 1.29-.786 1.778-.523.489-1.134.756-1.876.756s-1.353-.267-1.876-.756c-.524-.489-.786-1.067-.786-1.778 0-.71.262-1.289.786-1.777.523-.49 1.134-.712 1.876-.712s1.353.223 1.876.712c.524.488.786 1.066.786 1.777z"
    />
  </SVG>
);

const SoundcloudIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon soundcloud-icon', styles.socIcon, props.className)}
    viewBox="0 0 26 15"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M0 12.307c0 .336.117.59.35.761a.93.93 0 00.751.183c.25-.05.425-.143.526-.277.101-.134.152-.357.152-.667v-3.65c0-.26-.087-.48-.26-.66a.847.847 0 00-.636-.27c-.242 0-.45.09-.623.27-.173.18-.26.4-.26.66v3.65zm2.783 1.56c0 .244.082.426.248.548.165.121.377.182.635.182.266 0 .482-.06.647-.182.166-.122.248-.304.248-.548V5.361a.902.902 0 00-.26-.648.848.848 0 00-.635-.27c-.242 0-.45.09-.623.27a.902.902 0 00-.26.648v8.506zm2.77.403c0 .243.085.426.254.548.17.121.388.182.654.182.258 0 .47-.06.635-.182.165-.122.248-.305.248-.548V6.506a.94.94 0 00-.26-.667.825.825 0 00-.623-.277.857.857 0 00-.642.277.928.928 0 00-.266.667v7.764zm2.783.038c0 .461.298.692.895.692s.896-.23.896-.692V1.724c0-.705-.206-1.103-.617-1.195-.267-.069-.53.011-.787.239-.258.226-.387.545-.387.956v12.584zm2.831.365V.982c0-.437.125-.697.375-.78A6.872 6.872 0 0116.6.906a7.218 7.218 0 012.583 2.472 7.568 7.568 0 011.144 3.454 3.837 3.837 0 011.573-.327c1.129 0 2.095.415 2.897 1.246C25.6 8.582 26 9.58 26 10.747c0 1.174-.401 2.177-1.204 3.007-.802.83-1.764 1.246-2.885 1.246l-10.526-.013a.286.286 0 01-.164-.138.382.382 0 01-.054-.176z"
    />
  </SVG>
);

const TumblrIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon tumblr-icon', styles.socIcon, props.className)}
    viewBox="0 0 13 22"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M11.912 17.573c-.42.195-1.225.365-1.825.38-1.81.046-2.162-1.238-2.177-2.169V8.935h4.543v-3.33H7.926V0H4.614a.177.177 0 00-.164.164C4.257 1.88 3.432 4.89 0 6.094v2.841h2.29v7.188c0 2.461 1.866 5.958 6.793 5.876 1.663-.028 3.51-.705 3.917-1.29l-1.088-3.136"
    />
  </SVG>
);

const TwitterIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon twitter-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 20"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M24 2.368a9.617 9.617 0 01-2.827.794A5.038 5.038 0 0023.338.37a9.698 9.698 0 01-3.129 1.223A4.856 4.856 0 0016.616 0c-2.718 0-4.922 2.26-4.922 5.049 0 .396.042.78.126 1.15C7.728 5.988 4.1 3.979 1.67.922a5.14 5.14 0 00-.666 2.54c0 1.751.87 3.297 2.19 4.203a4.834 4.834 0 01-2.23-.63v.062c0 2.447 1.697 4.488 3.95 4.95a4.695 4.695 0 01-1.296.178c-.317 0-.627-.03-.927-.09.626 2.006 2.444 3.466 4.599 3.505A9.722 9.722 0 010 17.733 13.71 13.71 0 007.548 20c9.058 0 14.01-7.692 14.01-14.365 0-.22-.005-.439-.013-.654A10.1 10.1 0 0024 2.368"
    />
  </SVG>
);

const VimeoIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon vimeo-icon', styles.socIcon, props.className)}
    viewBox="0 0 22 19"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M21.989 4.393c-.096 2.141-1.594 5.068-4.483 8.783C14.515 17.059 11.98 19 9.91 19c-1.28 0-2.366-1.18-3.252-3.55-.594-2.173-1.184-4.347-1.776-6.514-.66-2.37-1.366-3.555-2.122-3.555-.164 0-.737.345-1.725 1.038L0 5.084a296.312 296.312 0 003.207-2.86C4.65.974 5.736.317 6.46.25 8.167.083 9.22 1.252 9.617 3.752c.423 2.7.721 4.377.885 5.035.494 2.237 1.035 3.353 1.628 3.353.459 0 1.15-.723 2.07-2.169.922-1.448 1.412-2.549 1.479-3.307.132-1.251-.36-1.872-1.478-1.872-.527 0-1.07.11-1.628.344C13.66 1.616 15.73-.096 18.787.004c2.265.064 3.335 1.53 3.202 4.389"
    />
  </SVG>
);

const YoutubeIcon = ({ width = 24, height = 24, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('soc-icon youtube-icon', styles.socIcon, props.className)}
    viewBox="0 0 24 17"
  >
    <path
      stroke="none"
      fillRule="evenodd"
      d="M9.522 11.635V4.844l6.484 3.407-6.484 3.384zM23.76 3.667s-.235-1.665-.954-2.399C21.893.305 20.87.301 20.401.245 17.043 0 12.005 0 12.005 0h-.01S6.957 0 3.599.245c-.47.056-1.492.06-2.406 1.023-.719.734-.953 2.4-.953 2.4S0 5.622 0 7.577v1.835c0 1.956.24 3.912.24 3.912s.234 1.665.953 2.399c.914.963 2.113.932 2.647 1.033C5.76 16.943 12 17 12 17s5.043-.008 8.401-.252c.47-.057 1.492-.061 2.405-1.024.72-.734.954-2.4.954-2.4s.24-1.954.24-3.91V7.579c0-1.956-.24-3.912-.24-3.912z"
    />
  </SVG>
);

// map of social icons
export default {
  aboutme: AboutMeIcon,
  angellist: AngelListIcon,
  facebook: FacebookIcon,
  flickr: FlickrIcon,
  foursquare: FoursquareIcon,
  github: GithubIcon,
  hackernews: HackerNewsIcon,
  instagram: InstagramIcon,
  linkedin: LinkedInIcon,
  medium: MediumIcon,
  pinterest: PinterestIcon,
  quora: QuoraIcon,
  reddit: RedditIcon,
  slideshare: SlideshareIcon,
  soundcloud: SoundcloudIcon,
  tumblr: TumblrIcon,
  twitter: TwitterIcon,
  vimeo: VimeoIcon,
  youtube: YoutubeIcon,
};
